import {ProcessClientOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ListingRendererType} from 'nav/expanded/ListingRendererConstants';

import ProcedureRunTaskListingRenderer from '../procedures/ProcedureRunTaskListingRenderer';

export default class AssayRunTaskListingRenderer extends ProcedureRunTaskListingRenderer<ListingRendererType.ASSAY_RUN_TASK> {
  listingRendererType = ListingRendererType.ASSAY_RUN_TASK;

  constructor() {
    super(ProcessClientOrigin.ASSAYS);
  }
}
